import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _applyDiscountToCheckoutRequest = {};
var _applyDiscountToCheckoutResponse = {};
var _queryLoyaltyCheckoutDiscountsRequest = {};
var _queryLoyaltyCheckoutDiscountsResponse = {};
function resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-checkout-exchange',
                destPath: '',
            },
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
            {
                srcPath: '/_api/loyalty-checkout-exchange',
                destPath: '/api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-checkout-exchange',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Applies a discount to a checkout.
 *
 * You can apply one of the following discounts, which are exchanged for loyalty points: `reward`, `loyaltyCoupon`, or `referralReward`.
 *
 * See the [introduction](https://dev.wix.com/docs/rest/crm/loyalty-program/checkout/introduction) article for more information on the type of rewards.
 */
export function applyDiscountToCheckout(payload) {
    var _a = serializer(_applyDiscountToCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyDiscountToCheckoutResponse, {}).fromJSON;
    function __applyDiscountToCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.checkoutexchange.v1.loyalty_checkout_discount',
            method: 'POST',
            methodFqn: 'wix.loyalty.checkoutexchange.v1.LoyaltyCheckoutExchange.ApplyDiscountToCheckout',
            url: resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl({
                protoPath: '/v1/loyalty-checkout-discount',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyDiscountToCheckout.fromReq = fromReq;
    __applyDiscountToCheckout.__isAmbassador = true;
    return __applyDiscountToCheckout;
}
/**
 * Retrieves a list of loyalty checkout discounts, given the provided paging, filtering, and sorting.
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryLoyaltyCheckoutDiscounts(payload) {
    var _a = serializer(_queryLoyaltyCheckoutDiscountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLoyaltyCheckoutDiscountsResponse, {}).fromJSON;
    function __queryLoyaltyCheckoutDiscounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.checkoutexchange.v1.loyalty_checkout_discount',
            method: 'POST',
            methodFqn: 'wix.loyalty.checkoutexchange.v1.LoyaltyCheckoutExchange.QueryLoyaltyCheckoutDiscounts',
            url: resolveWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutExchangeUrl({
                protoPath: '/v1/loyalty-checkout-discounts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLoyaltyCheckoutDiscounts.fromReq = fromReq;
    __queryLoyaltyCheckoutDiscounts.__isAmbassador = true;
    return __queryLoyaltyCheckoutDiscounts;
}
//# sourceMappingURL=http.impl.js.map